<template>
  <div>
    <Drawer title="车队卡详情" width="800" :value="showEdit" :mask-closable="true" @on-close="cancelEdit">
      <Card >
          <Form ref="editForm" :label-width="100" :model="formData">
            <FormItem label="车牌号" prop="car_number">
              <Input v-model="formData.car_number" placeholder=""></Input>
            </FormItem>
            <FormItem label="姓名" prop="user_name">
              <Input v-model="formData.user_name" placeholder="" maxlength="50"></Input>
            </FormItem>
          </Form>
        </Card>

        <div class="drawer-footer">
          <Button style="margin-right: 8px" @click="cancelEdit">取消</Button>
          <Button type="primary" @click="doSubmit">确定</Button>
        </div>

    </Drawer>
  </div>
</template>

<script>
  export default {
    name: "edit",
    props:{
      showEdit:{
        type:Boolean,
        default: false
      },
      cardId:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        baseInfo:{},
        formData:{
          card_id:0,
          company_id:'',
          balance:'',
          user_name:'',
          user_mobile:'',
          card_pwd:'',
          card_type:'',
          leader_id:'',
        },
        companys:[],
        leaders:[],
      }
    },
    methods:{
      async getInfo(){
        let res = await this.$commonFun.postProxy('admin/company/getCardInfo',{card_id:this.cardId});
        this.$commonFun.dealApiResult(res,()=>{
          if (this.cardId>0){
            this.formData = res.data.info;
            this.baseInfo = res.data.info;
          }
          this.companys = res.data.companys
        })
      },
      cancelEdit(){
         this.$emit('cancel-edit')
      },
      async doSubmit(){
        let api = this.cardId>0 ? 'admin/company/editCardBase' : 'admin/company/editCardBase';
        this.formData.card_id = this.cardId
        let res = await this.$commonFun.postProxy(api,this.formData);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$emit('edit-success')
          })
        })
      }
    },
    mounted() {
        this.getInfo()
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>
